import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { SvgIconsModule } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { svgIcons } from '@tekman/shared/utils';
import { FeaturesAlertComponent } from './alert/features-alert.component';
import { CardComponent } from './card/card.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { HubspotComponent } from './hubspot/hubspot.component';
import { UiModalComponent } from './modal/modal.component';
import { PrivateModeComponent } from './private-mode/private-mode.component';
import { SkeletonLoaderComponent } from './skeleton-loader/skeleton-loader.component';
import { TooltipComponent } from './tooltip/tooltip.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    SvgIconsModule.forChild(svgIcons),
    MatDialogModule,
    RouterModule,
  ],
  declarations: [
    SkeletonLoaderComponent,
    FeaturesAlertComponent,
    TooltipComponent,
    UiModalComponent,
    DropdownComponent,
    CardComponent,
    PrivateModeComponent,
    HubspotComponent,
  ],
  exports: [
    SkeletonLoaderComponent,
    FeaturesAlertComponent,
    TooltipComponent,
    UiModalComponent,
    DropdownComponent,
    CardComponent,
    PrivateModeComponent,
    HubspotComponent,
  ],
})
export class SharedComponentModule {}
